import type { SurveyBuilderManager } from '@/state/surveys/useSurveyBuilder';
import { cn } from 'helpers/cn';
import { Input } from '@/components/ui/input';
import { TEMPLATES } from '@/state/surveys/useSurveyBuilder';
import { SURVEY_TYPES } from 'definitions';

type StepTemplateProps = { manager: SurveyBuilderManager };

const FIELD_INPUT = 'border-line bg-field text-foreground h-9 rounded-lg text-body';

export const StepTemplate = ({ manager }: StepTemplateProps) => {
  const { draft, selectTemplate, questionsLocked } = manager;

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h2 className="text-foreground m-0 text-lede font-medium">What do you want to measure?</h2>
        <p className="supporting m-0">
          NPS, CSAT and CES are standard instruments, each with its own scale and wording. Custom is your own mix of
          questions.
        </p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2" data-tour="survey-builder-type">
        {SURVEY_TYPES.map((type) => {
          const template = TEMPLATES[type];
          const isSelected = draft.type === type;
          return (
            <button
              key={type}
              type="button"
              onClick={() => selectTemplate(type)}
              // The type is fixed once the survey has run, like its questions.
              disabled={questionsLocked && type !== draft.type}
              className={cn(
                'rounded-card border p-3.5 text-left transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-50',
                isSelected
                  ? 'bg-sel-bg border-sel-line text-foreground'
                  : 'border-line bg-panel2 hover:bg-hover text-foreground',
              )}
            >
              <p className="m-0 text-body font-medium">{type}</p>
              <p className="supporting m-0 mt-1">{template.blurb}</p>
            </button>
          );
        })}
      </div>

      <div className="space-y-1.5" data-tour="survey-builder-name">
        <label htmlFor="survey-name" className="micro-label block">
          Internal name
        </label>
        {/* Not shown to visitors — this is the label in the library. */}
        <Input id="survey-name" name="name" defaultValue={draft.name} maxLength={256} className={FIELD_INPUT} />
      </div>
    </div>
  );
};
